import React from "react";
import TopBar from "../TopBar/TopBar";
import { IPageProps } from "../types";
import { PageWrapper, Content } from "./styled";

const Page: React.FC<IPageProps> = ({ topBar, title, topBarHeight, stretch, padding, children }) => {
    React.useEffect(() => {
        if (title) document.title = title;
    }, [title]);

    const isDoubleBar: boolean = !!(
        topBar?.search ||
        topBar?.backlink ||
        topBar?.title ||
        topBar?.actions ||
        topBar?.tabs
    );

    return (
        <div>
            {topBar && <TopBar {...topBar} />}
            <PageWrapper $topBarHeight={topBarHeight} $isDoubleBar={isDoubleBar} $padding={padding} $stretch={stretch}>
                <Content $stretch={stretch}>{children}</Content>
            </PageWrapper>
        </div>
    );
};

export default Page;
